export const environment = {
  production: false,
  defaultauth: 'localhost',
  backend: 'https://api.nikki-staging.nl/api/',
  backend_web: 'https://api.nikki-staging.nl/',
  env: 'staging',
  name: 'NIKKI',
  locale: "en",
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "" 
  },
  sentry: {
    dsn: 'https://64a39151aac1433832703023845799f3@o4507735602298880.ingest.de.sentry.io/4509988052926544',
    environment: 'staging'
  }
};